const mixColor = function () {

  var keys = [32, 33, 34, 35, 36, 37, 38, 39, 40];

  var mainLogo = $(".main-container__logo");
  var colorChangeHook = $(".fixed-top");
  var nav = $(".navigation-toggle");
  var windowH = $(window).height();
  var windowW = $(window).width();

  var differenceOn = function () {
    colorChangeHook.each(function () {
      colorChangeHook.addClass('color-change')
    })
  }
  var differenceOff = function () {
    colorChangeHook.each(function () {
      colorChangeHook.removeClass('color-change')
    })
  }

  function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
      e.preventDefault();
    e.returnValue = false;
  }

  function keydown(e) {
    for (var i = keys.length; i--;) {
      if (e.keyCode === keys[i]) {
        preventDefault(e);
        return;
      }
    }
  }

  function wheel(e) {
    preventDefault(e);
  }

  function disable_scroll() {
    if (window.addEventListener) {
      window.addEventListener('DOMMouseScroll', wheel, false);
    }
    window.onmousewheel = document.onmousewheel = wheel;
    document.onkeydown = keydown;
    disable_scroll_mobile();
  }

  function enable_scroll() {
    if (window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', wheel, false);
    }
    window.onmousewheel = document.onmousewheel = document.onkeydown = null;
    enable_scroll_mobile();
  }

  // MOBILE
  function disable_scroll_mobile() {
    document.addEventListener('touchmove', preventDefault, false);
  }

  function enable_scroll_mobile() {
    document.removeEventListener('touchmove', preventDefault, false);
  }


  // Enable scroll on page load
  enable_scroll();

  // Color depends on status of the menu
  nav.each(function () {
    this.addEventListener("click", function () {
      if (-parseInt($(".navigation.expanded").css("left")) != windowW) {
        if ($(window).scrollTop() + 65 > windowH) {
          setTimeout(function () {
            differenceOn();
          }, 1000);
        }
        enable_scroll()
        mainLogo.removeClass('black')
      } else {
        differenceOff();
        disable_scroll()
        mainLogo.addClass('black')
      }
    })
  })

  // Color depends on scroll position
  window.addEventListener("scroll", function () {
    if ($(window).scrollTop() + 65 > windowH && -parseInt($(".navigation.expanded").css("left")) != windowW) {
      differenceOn();
    } else {
      differenceOff();
    }
  });

  // Resize
  window.addEventListener("resize", function () {
    windowH = $(window).height();
  });
}

export default mixColor;



// WEBPACK FOOTER //
// ./src/js/functions.js